import { Component, OnInit } from '@angular/core';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import {TopicService} from "../../service/topic.service";
import {Globals } from '../../globals';
import {commonService  } from '../../service/common.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-topicdetail',
  templateUrl: './topicdetail.component.html',
  styleUrls: ['./topicdetail.component.css'],
  providers:[TopicService,Globals],
})
export class TopicdetailComponent implements OnInit {
  formoption:any;
  topicId:any=0;
  topicDetail:any={};
  user:any={};
  msg="";

  constructor(private global:Globals, private router: Router,private route: ActivatedRoute,private topicService:TopicService,private commonService:commonService) {
   
    this.route.params.subscribe((params: Params) => {
      if(params['id']){
        try{
          if(this.topicId > 0){
            this.topicId = atob(params['id']);
            this.formoption={createpost:false,topicId:this.topicId}
            this.getTopicDetail();
          }else{
            this.topicId = atob(params['id']);
            this.formoption={createpost:false,topicId:this.topicId}
          }         
        }catch(e){
          this.topicId=0;

        }
      }   
    });

    this.commonService.profile.subscribe((data:any)=>{
       if(data){
       this.user=data; 
       this.getTopicDetail();
       }else{
         this.user={};
       } 
 
     });
  
   }

  ngOnInit() {
//console.log('topic nginit');
    this.getTopicDetail();
  }

  getTopicDetail(){
  var obj={};
  obj['topicId']=this.topicId;
  obj['userId']=(this.user.id)?this.user.id:0;
 // console.log('query obj');
  //console.log(obj);
  this.topicService.getTopicDetail(obj).subscribe((data:any)=>{
   // console.log(data);
    if(data.error==0){
      this.topicDetail=data.results;
    }

  },(error:HttpErrorResponse)=>{
    this.msg="internal server error!";

  })

  }

  getTopicImage(path,width){
    //return this.global.topicImageUrl+imageName;
    return this.global.websiteImgUrl+this.global.topicFolder+'/'+path+'&width='+width;
   }

   topicFollow(topicDetail){
    if(Object.keys(this.user).length == 0){ 
      this.commonService.setLoginBox(true); 
      return false;
    } 
    let obj={topicId:topicDetail.id,userId:this.user.id};
    //console.log(obj);

    this.topicService.saveFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount +=1;
      topicDetail.followerCount +=1;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })

    
   }
   topicUnFollow(topicDetail){
    if(Object.keys(this.user).length == 0){ 
      this.commonService.setLoginBox(true); 
      return false;
    } 
    let obj={topicId:topicDetail.id,userId:this.user.id};
    this.topicService.saveunFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount -=1;
      topicDetail.followerCount -=1;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })
   }


   topicbookmark(topicDetail){
    if(Object.keys(this.user).length == 0){ 
      this.commonService.setLoginBox(true); 
      return false;
    } 
    let obj={topicId:topicDetail.id,userId:this.user.id};
    this.topicService.topicbookmark(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.ismybookmark =1;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })

    
   }
   topicunbookmark(topicDetail){
    if(Object.keys(this.user).length == 0){ 
      this.commonService.setLoginBox(true); 
      return false;
    } 

    let obj={topicId:topicDetail.id,userId:this.user.id};
    this.topicService.topicunbookmark(obj).subscribe((data:any)=>{
      if(data.error==0){
        topicDetail.ismybookmark =0;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })
   }

   

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/topicdetail/topicdetail.component.ts